import React from 'react';

import ContextMenu from 'flow/components/ContextMenu';
import SupervisorQueueContextMenu from 'flow/components/context-menus/SupervisorQueueContextMenu';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectQueueDescription } from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import { getMoreOptionsLabel } from 'flow/utils/a11y-utils';

interface Props {
    queueKey: QueueKey;
    setActive: (value: boolean) => void;
}

// Own component so the queue's name and the translation subscription stay off
// the row, which re-renders on every waiting-call and agent change.
const SupervisorQueueRowMenu = ({ queueKey, setActive }: Props) => {
    const { i18next } = useAppContext();
    const queueName = useAppSelector((state) =>
        selectQueueDescription(state, queueKey),
    );

    return (
        <ContextMenu
            triggerLabel={getMoreOptionsLabel(i18next, queueName)}
            setActive={setActive}
            preventOverflow={true}
            className="bg-gray-200"
        >
            <SupervisorQueueContextMenu queueKey={queueKey} />
        </ContextMenu>
    );
};

export default SupervisorQueueRowMenu;
